import { createContext, useContext } from "react";

import { useMappingData } from "./useMappingData";

const MappingContext = createContext<ReturnType<typeof useMappingData> | null>(
  null,
);

export function useMappingDataContext() {
  const context = useContext(MappingContext);
  if (!context) {
    throw new Error("useMappingContext must be used within a MappingProvider");
  }
  return context;
}

export function MappingDataProvider({
  children,
  ...mappingData
}: ReturnType<typeof useMappingData> & {
  children: React.ReactNode;
}) {
  return (
    <MappingContext.Provider value={mappingData}>
      {children}
    </MappingContext.Provider>
  );
}
